import TopLeaderBoard from './TopLeaderBoard';
export default TopLeaderBoard;
